






















import { Component, Vue } from "vue-property-decorator";
import { configuration } from "@/config/host.config";
import { ISettings } from "@/@types/filoxenia-config/tv-config";

import BSwitch from "@/components/app/switchs/b-switch.vue";
import StandartModal from "@/components/app/standart-modal.vue";

@Component({ components: { StandartModal, BSwitch } })
export default class WeatherSettings extends Vue {
  conponent = "";

  async updateSetting(data: Partial<ISettings>): Promise<void> {
    try {
      const params = { app: "settings" };
      const configRes = await this.$axios.put(configuration.mainAPI, data, {
        params,
      });
      if (configRes.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.createSettings();
      } else
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
    } catch (error) {
      console.log(error);
    }
  }

  async createSettings(): Promise<void> {
    try {
      const config = { params: { "match[app]": "settings" } };
      const configRes = await this.$axios.get(configuration.mainAPI, config);
      if (configRes.status === 200) {
        console.log(configRes.data);
        this.conponent = configRes.data.settings.weather;
      }
    } catch (error) {
      console.log(error);
    }
  }

  mounted(): void {
    this.createSettings();
  }
}
